import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { SectionDivider } from './ui/SectionDivider';
export function BonosSection() {
  const bonos = [{
    title: 'Planificador de Mañanas Tranquilas',
    price: '$7.999'
  }, {
    title: 'Kit de Emergencias Escolares',
    price: '$7.999'
  }, {
    title: 'Guía de Comunicación con el Colegio',
    price: '$7.999'
  }, {
    title: 'Calendario Anual de Rutinas Escolares',
    price: '$7.999'
  }, {
    title: 'Guía de Crianza Emocional',
    price: '$7.999'
  }, {
    title: 'Sistema de Recompensas Positivas',
    price: '$7.999'
  }];
  return <section id="bonos" className="py-24 bg-coral relative mt-10" data-id="element-17">
      <SectionDivider position="top" fillColor="fill-coral" data-id="element-18" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-19">
        <AnimatedSection className="text-center mb-16" data-id="element-20">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-white" data-id="element-21">
            🎁Más los{' '}
            <span className="bg-yellow-300 text-burgundy px-3 py-1 rounded-lg inline-block" data-id="element-22">
              6 Bonos Exclusivos
            </span>
          </h2>
          <p className="text-white/80 text-base md:text-lg mt-3 font-medium tracking-wide" data-id="element-23">
            Incluidos en todas las ofertas – Sin costo extra
          </p>
        </AnimatedSection>

        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-3 md:gap-4 max-w-3xl mx-auto" style={{
        perspective: '1200px'
      }} data-id="element-24">
          {bonos.map((bono, index) => {
          const schemes = [{
            bg: 'bg-white',
            border: 'border-white/80',
            title: 'text-charcoal',
            price: 'text-charcoal/40',
            badge: 'bg-rose/20 text-coral'
          }, {
            bg: 'bg-cream',
            border: 'border-rose/20',
            title: 'text-burgundy',
            price: 'text-burgundy/40',
            badge: 'bg-burgundy/10 text-burgundy'
          }, {
            bg: 'bg-white',
            border: 'border-white/80',
            title: 'text-charcoal',
            price: 'text-charcoal/40',
            badge: 'bg-coral/15 text-coral'
          }, {
            bg: 'bg-cream',
            border: 'border-rose/20',
            title: 'text-burgundy',
            price: 'text-burgundy/40',
            badge: 'bg-burgundy/10 text-burgundy'
          }, {
            bg: 'bg-white',
            border: 'border-white/80',
            title: 'text-charcoal',
            price: 'text-charcoal/40',
            badge: 'bg-rose/20 text-coral'
          }, {
            bg: 'bg-cream',
            border: 'border-rose/20',
            title: 'text-burgundy',
            price: 'text-burgundy/40',
            badge: 'bg-coral/15 text-coral'
          }];
          const s = schemes[index];
          return <AnimatedSection key={index} delay={index * 0.08} className={`${s.bg} ${s.border} border rounded-xl p-3 md:p-4 text-center card-3d cursor-pointer`} data-id="element-25">
                <span className="text-2xl block mb-1" data-id="element-26">🎁</span>
                <span className={`inline-block font-bold text-[10px] tracking-wider uppercase px-2.5 py-0.5 rounded-full mb-2 ${s.badge}`} data-id="element-27">
                  Bono {index + 1}
                </span>
                <h3 className={`text-xs md:text-sm font-serif font-bold leading-snug mb-1 ${s.title}`} data-id="element-28">
                  {bono.title}
                </h3>
                <div className="flex items-center justify-center gap-1.5 mt-1" data-id="element-29">
                  <p className={`text-xs md:text-sm line-through font-semibold ${s.price} opacity-70`} data-id="element-30">
                    {bono.price}
                  </p>
                  <span className="bg-yellow-300 text-burgundy font-black text-[10px] md:text-xs px-2 py-0.5 rounded-full uppercase tracking-wide" data-id="element-31">
                    Gratis
                  </span>
                </div>
              </AnimatedSection>;
        })}
        </div>

        <AnimatedSection delay={0.6} className="mt-16 text-center" data-id="element-32">
          <div className="inline-block bg-burgundy/20 border border-white/30 rounded-full px-8 py-4 backdrop-blur-sm" data-id="element-33">
            <p className="text-xl md:text-2xl font-bold text-white" data-id="element-34">
              Valor total de bonos: $47.994 •{' '}
              <span className="text-yellow-300" data-id="element-35">
                🎁 GRATIS -¡Incluidoss siempre en todas las ofertas!
              </span>
            </p>
          </div>
        </AnimatedSection>
      </div>

      <SectionDivider position="bottom" fillColor="fill-coral" data-id="element-36" />
    </section>;
}